import React from "react";
import { useTranslation } from "react-i18next";
import { useRemoveEvent } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function EventRemoval({ event, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeEvent } = useRemoveEvent(event);

  return (
    <Modal
      header={t("removeEvent.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>{t("removeEvent.group")}</p>
          <p className={styles.name}>{`> ${event.name}`}</p>
          <p className={styles.text}>{t("removeEvent.removal")}</p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeEvent.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() => removeEvent(event)}
          >
            {t("removeEvent.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { EventRemoval };
